import React from 'react';
import { CountdownTimer } from './CountdownTimer';
const CHECKOUT_URL = 'https://ready-tennis.impultienda.ar/checkout';
export function FinalCTASection() {
  return <section aria-label="Final call to action" className="bg-brand-dark text-white py-24 px-4 relative border-t border-brand-border" data-id="element-77">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-78">
        <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-6" data-id="element-79">
          <span className="text-xl" aria-hidden="true" data-id="element-80">
            🎾
          </span>{' '}
          TENNIS READY
        </div>
        <p className="text-xl md:text-2xl text-white/70 mb-4 italic" data-id="element-81">
          Next Monday, you could arrive on court tired, after a Sunday night
          spent in front of a laptop.
        </p>
        <p className="text-2xl md:text-3xl font-heading font-bold text-brand-accent mb-16" data-id="element-82">
          Or you could arrive smiling, knowing that your entire year of Tennis
          is already planned out and solved for you.
        </p>
        <div className="mb-12" data-id="element-83">
          <CountdownTimer data-id="element-84" />
        </div>

        <div className="max-w-md mx-auto mb-16" data-id="element-85">
          <div className="bg-brand-card p-6 md:p-8 rounded-2xl border-2 border-brand-accent flex flex-col items-center shadow-[0_0_30px_rgba(0,255,133,0.15)]" data-id="element-86">
            <div className="font-bold text-brand-accent mb-2 text-sm uppercase tracking-widest" data-id="element-87">
              ⚡ THE ULTIMATE PRO BUNDLE
            </div>
            <div className="text-4xl md:text-5xl font-heading font-bold text-brand-accent mb-5" data-id="element-88">
              $27
            </div>
            <button onClick={() => window.open(CHECKOUT_URL, '_blank')} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark py-4 rounded-2xl text-base font-black transition-colors" data-id="element-89">
              → I WANT TENNIS READY
            </button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-white/70 font-medium mb-16 text-sm" data-id="element-90">
          <span data-id="element-91">🔒 Secure Payment</span>
          <span data-id="element-92">⚡ Access in 5 minutes</span>
          <span data-id="element-93">🛡️ 7-Day Guarantee</span>
          <span data-id="element-94">💳 Card | PayPal | Bank Transfer</span>
        </div>
        <div className="border-t border-brand-border pt-12 max-w-2xl mx-auto" data-id="element-95">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-xs uppercase mb-4" data-id="element-96">
            <span aria-hidden="true" data-id="element-97">🎾</span> TENNIS READY
          </div>
          <p className="text-white/60 italic mb-2 text-sm" data-id="element-98">
            The "turnkey" system for tennis coaches and teaching professionals.
          </p>
          <p className="text-white/60 italic text-sm" data-id="element-99">
            Because coaching Tennis should be a passion, not a second full-time
            job at home.
          </p>
        </div>
      </div>
    </section>;
}